export default {"src":"/_next/static/media/twitter.a75d45c0.svg","height":18,"width":22,"blurWidth":0,"blurHeight":0};